// extracted by mini-css-extract-plugin
export default {"search":"SearchFiead_search__XbWn4","search__field":"SearchFiead_search__field__gxLWz"};